var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"d-flex flex-column justify-space-between align-center",attrs:{"height":"100vh","flat":""}},[_c('div',{staticClass:"logo-loading"}),_c('v-row',[_c('v-col',{attrs:{"align-self":"center"}},[_c('v-progress-circular',{attrs:{"size":"200","indeterminate":"","color":"secondary"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }